
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/[$partnerName]/localMain",
      function () {
        return require("private-next-pages/partners/[$partnerName]/localMain.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/[$partnerName]/localMain"])
      });
    }
  